namespace Matrix.Administration {
    export interface PermissionListResponse extends Serenity.ListResponse<string> {
    }
}
